<script>
export default {
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
    slice: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {}
  },
  mounted() {
    defineSlice({
      name: { label: 'Title Subtitle', group: 'global', layouts: ['*'] },
      preview: 'SlicesGlobalIntroductionsTitleSubtitle.jpg',
      tags: ['Title', 'Subtitle'],
      fields: {
        title: {
          type: 'text',
          label: 'Title',
          group: 'Title',
          editorLabel: true,
          enabled: false,
          name: 'title',
        },
        titleTag: {
          group: 'Title',
          type: 'select',
          label: 'Title Tag',
          options: { h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6' },
          default: 'h2',
        },
        titleSize: {
          type: 'select',
          label: 'Title Size',
          group: 'Title',
          options: {
            'text-sm': 'Small',
            'text-base': 'Base',
            'text-lg': 'Large',
            'text-xl': 'XL',
            'text-2xl': '2XL',
            'text-3xl': '3XL',
            'text-4xl': '4XL',
            'text-5xl': '5XL',
          },
          default: 'text-4xl',
        },
        titleColor: {
          group: 'Title',
          type: 'color',
          label: 'Title Color',
          default: '#000',
        },
        subtitle: {
          type: 'text',
          label: 'Sub-title',
          group: 'Subtitle',
          enabled: false,
          name: 'subtitle',
        },
        subtitleTag: {
          group: 'Subtitle',
          type: 'select',
          label: 'Subtitle Tag',
          options: { h1: 'h1', h2: 'h2', h3: 'h3', h4: 'h4', h5: 'h5', h6: 'h6' },
          default: 'h3',
        },
        subtitleSize: {
          type: 'select',
          label: 'Subtitle Size',
          group: 'Subtitle',
          options: {
            'text-sm': 'Small',
            'text-base': 'Base',
            'text-lg': 'Large',
            'text-xl': 'XL',
            'text-2xl': '2XL',
            'text-3xl': '3XL',
            'text-4xl': '4XL',
            'text-5xl': '5XL',
          },
          default: 'text-3xl',
        },
        subtitleColor: {
          group: 'Subtitle',
          type: 'color',
          label: 'Subtitle Color',
          default: '#000',
        },
      },
      slots: [],
    })
  },
}
</script>

<template>
  <div
    v-if="fields.title.enabled || fields.subtitle.enabled"
    class="relative mt-8 md:mt-0 flex justify-center"
  >
    <div
      class="px-8 md:px-16 container flex flex-col justify-center items-center text-center"
    >
      <!-- Title -->
      <div
        class="mb-8"
        :style="{ color: fields.titleColor.value }"
        v-html="`<${fields.titleTag.value} class='${fields.titleSize.value} font-light'> ${fields.title.value} </${fields.titleTag.value}>`"
      />

      <!-- Subtitle -->
      <div
        v-if="fields.subtitle.enabled"
        class="mb-8 w-full"
        :style="{ color: fields.subtitleColor.value }"
        v-html="`<${fields.subtitleTag.value} class='${fields.subtitleSize.value} run-through'> ${fields.subtitle.value} </${fields.subtitleTag.value}>`"
      />
    </div>
  </div>
</template>
